// extracted by mini-css-extract-plugin
export default {"searchTag":"searchTag__yVGHir","searchTagWide":"searchTagWide__me4J1P","searchTagNarrow":"searchTagNarrow__YpwaMd","resetButton":"resetButton__CWWWYZ"};